import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "How does athlete financial planning differ?",
      answer: "Athletes face unique career trajectories, which need specially tailored financial strategies, ensuring stability and growth."
    },
    {
      question: "What investments suit sports professionals?",
      answer: "Diverse, risk-assessed portfolios, considering potential future earnings and career duration, are ideal."
    },
    {
      question: "How can tax be optimised for athletes?",
      answer: "Sportspersons benefit from certain tax structures; we guide on maximising these advantages."
    },
    {
      question: "How do you handle sudden income spikes?",
      answer: "Through planned investments, ensuring immediate and future financial stability, maximising the benefits."
    },
    {
      question: "Is insurance crucial for sportspersons?",
      answer: "Yes, tailored insurance plans cover potential health risks, ensuring peace of mind."
    },
    {
      question: "How do legacy and brand investments fit in?",
      answer: "We guide on smart investments ensuring long-term prosperity and a strong legacy post-retirement."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Frequently Asked Questions About Athlete Financial Planning
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to common questions about financial planning for sports professionals.
              For more detailed guidance, our experts are here to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
